// extracted by mini-css-extract-plugin
module.exports = {"frame":"devices_frame__2bFNk","iphone":"devices_iphone___aTWq","android":"devices_android__61vK6","screen":"devices_screen__b-B_E","shown":"devices_shown__1kKyq"};